import services from '.'
import { ILoginPayload, ILoginResponse, ISingUpPayload, IUser } from '../@types'
import ERROR_MESSAGES from '../database/error-messages'
import { getAxiosErrorMessage } from '../resources'

async function login({
  email,
  password,
}: ILoginPayload): Promise<IUser | undefined> {
  try {
    const result = await services.api.post<ILoginResponse>('/users/auth', {
      email,
      password,
    })

    if (!result.data) throw new Error(ERROR_MESSAGES.serverError)
    const { data } = result.data
    if (!data) throw new Error(ERROR_MESSAGES.serverError)
    return data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function signUp({
  name,
  email,
  password,
}: ISingUpPayload): Promise<IUser | undefined> {
  try {
    const result = await services.api.post<ILoginResponse>('/users', {
      name,
      email,
      password,
    })

    if (!result.data) throw new Error(ERROR_MESSAGES.serverError)
    const { data } = result.data
    if (!data) throw new Error(ERROR_MESSAGES.serverError)
    return data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default { login, signUp }
